import { api } from '../api/client.js';

export function getJrSummary() {
  return api.get('/maklerOverview/summary').then((r) => r.data.data);
}

export function getMaklerProfileAdmin(maklerId) {
  return api.get(`/core/makler/${maklerId}/profile-admin`).then((r) => r.data.data);
}

export function updateMaklerProfile(maklerId, payload) {
  return api.patch(`/core/makler/${maklerId}/profile`, payload).then((r) => r.data);
}

export function addTimelineEvent(maklerId, payload) {
  return api.post(`/core/makler/${maklerId}/timeline`, payload).then((r) => r.data.data);
}

export function deleteTimelineEvent(eventId) {
  return api.delete(`/core/timeline/${eventId}`).then((r) => r.data);
}

export function getCalendar(days = 30) {
  return api.get('/maklerOverview/calendar', { params: { days } }).then((r) => r.data.data.events);
}

export function listSettings() {
  return api.get('/system-settings').then((r) => r.data.data.settings);
}

export function saveSetting(setting, value) {
  return api
    .patch(`/system-settings/${encodeURIComponent(setting.key)}`, {
      key: setting.key,
      value,
      valueType: setting.value_type,
      description: setting.description,
      category: setting.category,
    })
    .then((r) => r.data.data);
}
